import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import favicon from '../../../Assets/Images/favicon.png'
import AnimateHeight from 'react-animate-height'
import CustomAlert from '../../../Components/Alert'
import fetchApiError from '../../../Helpers/fetchApiError'
import { useForm } from '../../../Hooks/useForm'
import TrackingService from '../../../Services/Tracking'
import './styles.scss'

const Tracker = ({ setTrackItResult }) => {
  const { form, onChange, reset } = useForm({
    trackingNumber: '',
    loading: false,
    error: null,
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { return reset }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    onChange('loading', true)
    onChange('error', null)
    try {
      const res = await TrackingService.get_by_tracking_number(form.trackingNumber)
      setTrackItResult(res.data.data)
    } catch (error) {
      setTrackItResult(null)
      onChange('error', fetchApiError(error))
    }
    onChange('loading', false)
  }

  return (
    <div className="tracker">
      <div className="tracker__card">
        <div className="tracker__icon-wrap">
          <img src={favicon} alt="Stanbit Logistics" />
        </div>

        <h2>Track Your Shipment</h2>
        <p className="tracker__desc">
          Enter your tracking number below to get real-time updates on your shipment's location and status.
        </p>

        <form onSubmit={handleSubmit} className="tracker__form">
          <div className="tracker__input-wrap">
            <FontAwesomeIcon icon={solid('barcode')} className="tracker__input-icon" />
            <input
              type="text"
              placeholder="Enter tracking number (e.g. SBL-2024-001234)"
              value={form.trackingNumber}
              onChange={(e) => onChange('trackingNumber', e.target.value)}
              required
            />
          </div>

          <AnimateHeight duration={300} height={form.error ? 'auto' : 0}>
            <div className="tracker__error">
              <CustomAlert variant="danger" message={form.error} />
            </div>
          </AnimateHeight>

          <button
            type="submit"
            className={`tracker__btn${form.loading ? ' loading' : ''}`}
            disabled={form.loading}
          >
            {form.loading ? (
              <><FontAwesomeIcon icon={solid('spinner')} className="spin" /> Tracking…</>
            ) : (
              <><FontAwesomeIcon icon={solid('magnifying-glass')} /> Track Shipment</>
            )}
          </button>
        </form>

        <p className="tracker__hint">
          <FontAwesomeIcon icon={solid('circle-info')} />
          Your tracking number can be found in your shipping confirmation email.
        </p>
      </div>
    </div>
  )
}

export default Tracker
